module.exports = __webpack_public_path__ + "img/page_bg_patrolShop.9d08c0c7.png";